import type { CSSProperties } from 'react';
import { ICON_REGISTRY } from '../../components/surface/content/icon-registry';

interface CalloutProps {
  text: string;
  variant?: 'info' | 'warning' | 'success' | 'error';
  icon?: string;
  className?: string;
  style?: CSSProperties;
}

const VARIANT_STYLES: Record<string, string> = {
  info: 'bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-950 dark:border-blue-800 dark:text-blue-200',
  warning:
    'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950 dark:border-amber-800 dark:text-amber-200',
  success:
    'bg-green-50 border-green-200 text-green-800 dark:bg-green-950 dark:border-green-800 dark:text-green-200',
  error:
    'bg-red-50 border-red-200 text-red-800 dark:bg-red-950 dark:border-red-800 dark:text-red-200',
};

const DEFAULT_ICONS: Record<string, string> = {
  info: 'Info',
  warning: 'AlertTriangle',
  success: 'CheckCircle',
  error: 'XCircle',
};

export function CalloutView({ text, variant = 'info', icon, className, style }: CalloutProps) {
  const IconComponent = ICON_REGISTRY[icon ?? DEFAULT_ICONS[variant] ?? 'Info'];
  return (
    <div
      className={`flex items-start gap-2 rounded-md border p-3 text-sm ${VARIANT_STYLES[variant] ?? VARIANT_STYLES.info}${className ? ` ${className}` : ''}`}
      style={style}
    >
      {IconComponent && <IconComponent className="mt-0.5 h-4 w-4 shrink-0" />}
      <span>{text}</span>
    </div>
  );
}
